"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var DepositCancelModal = function (_a) {
    var supportEmail = _a.supportEmail;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    return (react_1.default.createElement(ui_components_1.Modal, { width: "500px", height: "auto", padding: "0", saveSize: true },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t("paymentCancel")),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.description },
                    t('paymentCancelDescription'),
                    ' ',
                    react_1.default.createElement("a", { className: styles_module_scss_1.default.link, href: "mailto:".concat(supportEmail) }, supportEmail)),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                    react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", maxWidth: "320px", text: "upper", onClick: isAuth ? openDeposit : openSignUp }, t("continue")))))));
};
exports.default = DepositCancelModal;
